import fs from 'fs';
import { Parts } from '../../core/Parts';
import { FileReaderAbortError, FileReaderNotFoundError, FileReaderNotReadableError, FileReaderSecurityError, FileReaderUnknownError, FileSystemAbortError, FileSystemNotFoundError, FileSystemPermissionDeniedError, FileSystemUnknownError, UnsupportedFileSourceError, UnsupportedFileTypeError } from '../../errors/errors';
import { TaskError } from '../../errors/TaskError';
import { UploaderError } from '../../errors/UploaderError';
import { MAX_EXECUTION_NUMBER } from '../../globals/constant';
import { buildPartRetryCountMapKey } from '../../helpers/id';
import { isNode } from '../../helpers/isNode';
import { AbstractTask } from './AbstractTask';
import { CreateParts } from './CreateParts';
import { UpdateFile } from './UpdateFile';
import { UpdateParts } from './UpdateParts';
export class UploadPart extends AbstractTask {
    constructor(context, file, part) {
        super(context);
        this.nativeFatalErrors = [
            FileSystemNotFoundError,
            FileSystemPermissionDeniedError,
            FileSystemUnknownError,
            FileReaderNotFoundError,
            FileSystemAbortError,
            FileReaderSecurityError,
            FileReaderNotReadableError,
            FileReaderUnknownError,
            FileReaderAbortError,
            UnsupportedFileSourceError,
            UnsupportedFileTypeError,
        ];
        this.transfer = context.transfer;
        this.file = file;
        this.part = part;
    }
    preProcess(context) {
        return this;
    }
    process() {
        return new Promise(async (resolve) => {
            try {
                const content = await this.getContent(this.file, this.part);
                const uploadTransferFilePartParameters = {
                    url: this.part.url,
                    content,
                    onUploadProgress: this.onUploadProgress.bind(this),
                };
                this.response = await this.context.transferSdk.uploadTransferFilePart(uploadTransferFilePartParameters);
            }
            catch (error) {
                if (error instanceof this.context.transferSdk.errors.UploadTransferFilePart.BadRequestError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InternalServerError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.UnknownError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.NoSuchUploadError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.AccessControlListNotSupportedError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.AccessDeniedError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.AccessPointAlreadyOwnedByYouError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.AccountProblemError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.AllAccessDisabledError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.AmbiguousGrantByEmailAddressError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.AuthorizationHeaderMalformedError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.EntityTooSmallError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.EntityTooLargeError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.IllegalLocationConstraintExceptionError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.IllegalVersioningConfigurationExceptionError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.IncompleteBodyError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InlineDataTooLargeError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidAccessKeyIdError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidArgumentError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidBucketNameError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidBucketStateError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidDigestError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidLocationConstraintError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidObjectStateError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidPartError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidPayerError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidPolicyDocumentError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidRangeError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidSecurityError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidDigestError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidTokenError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidURIError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.KeyTooLongError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.MaxMessageLengthExceededError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.MetadataTooLargeError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.MissingContentLengthError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.MissingRequestBodyError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.MissingSecurityHeaderError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.NoSuchBucketError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.NoSuchBucketPolicyError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.NoSuchCORSConfigurationError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.NoSuchKeyError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.NotImplementedError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.RequestHeaderSectionTooLargeError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.ServerSideEncryptionConfigurationNotFoundError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.ServiceUnavailableError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.UnexpectedContentError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.UserKeyMustBeSpecifiedError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.BadRequestError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InternalServerError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.UnknownError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePartError.BadDigestError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidDigestError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.ExpiredTokenError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InternalError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidTokenError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.RequestTimeoutError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.RequestTimeTooSkewedError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.SignatureDoesNotMatchError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.SlowDownError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.TokenRefreshRequiredError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.NetworkError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.ConnectionAbortedError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.TimeoutError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.EtagIsMissingError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.AuthorizationQueryParametersError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.ConditionalRequestConflictError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.EndpointNotFoundError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.IncorrectEndpointError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidAccessPointError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidAccessPointAliasError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidAddressingHeaderError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidEncryptionAlgorithmError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidHostHeaderError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidSessionExceptionError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidSignatureError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.InvalidStorageClassError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.MissingAuthenticationTokenError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.TokenCodeInvalidError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.UnauthorizedAccessError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.UnexpectedIPError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.UnsupportedArgumentError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.UnsupportedSignatureError ||
                    error instanceof this.context.transferSdk.errors.UploadTransferFilePart.NoSuchAccessPointError) {
                    this.error = new TaskError(this, error);
                }
                else {
                    this.error = new TaskError(this, error);
                }
            }
            resolve(this);
        });
    }
    onUploadProgress(event) {
        this.file.populateUploadingPart(this.part, { uploadedBytes: event.uploadedBytes });
    }
    postProcess(context) {
        this.transfer.populateUploadedPart(this.file, this.part, this.response);
        if (this.file.isFastUploadMode()) {
            if (this.file.hasEnoughPartsUploadedToCompleteFile()) {
                context.updateFileQueue.add(new UpdateFile(this.context, this.file));
            }
        }
        else if (this.file.isStandardUploadMode() && this.file.hasEnoughPartsToValidate()) {
            const parts = this.file.getNextPartsToValidate();
            const task = new UpdateParts(this.context, this.file, parts);
            return task;
        }
        return null;
    }
    processError() {
        if (this.error) {
            if (this.error.isInstanceOfOneOfTheseErrors(this.nativeFatalErrors)) {
                this.error.unrecoverableError(this.error.getError());
            }
            else if (this.error.getError() instanceof this.context.transferSdk.errors.UploadTransferFilePart.NetworkError ||
                this.error.getError() instanceof this.context.transferSdk.errors.UploadTransferFilePart.ConnectionAbortedError ||
                this.error.getError() instanceof this.context.transferSdk.errors.UploadTransferFilePart.TimeoutError ||
                this.error.getError() instanceof this.context.transferSdk.errors.UploadTransferFilePart.RequestTimeoutError ||
                this.error.getError() instanceof this.context.transferSdk.errors.UploadTransferFilePart.EtagIsMissingError) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else if (this.executionNumber < this.maxExecutionNumber &&
                (this.error.getError() instanceof this.context.transferSdk.errors.UploadTransferFilePart.InternalError ||
                    this.error.getError() instanceof this.context.transferSdk.errors.UploadTransferFilePart.RequestTimeTooSkewedError ||
                    this.error.getError() instanceof this.context.transferSdk.errors.UploadTransferFilePart.SignatureDoesNotMatchError ||
                    this.error.getError() instanceof this.context.transferSdk.errors.UploadTransferFilePart.SlowDownError)) {
                this.error.setRecoveryTask(this.error.getTask(), { backoffEnabled: true });
            }
            else if (this.canRetryPart()) {
                this.retryPart();
            }
            else {
                this.error.unrecoverableError(new UploaderError(this.error.getError()));
            }
            return this.error;
        }
        throw new Error('Method task.processError() should be called only if task.isOnError() === true');
    }
    canRetryPart() {
        var _a;
        const key = buildPartRetryCountMapKey({ transferId: this.context.transfer.id, fileId: this.file.id, partId: this.part.id });
        const retryPartCount = (_a = this.context.partRetriesCountMap.get(key)) !== null && _a !== void 0 ? _a : 0;
        if (retryPartCount < MAX_EXECUTION_NUMBER) {
            this.context.partRetriesCountMap.set(key, retryPartCount + 1);
            return true;
        }
        return false;
    }
    retryPart() {
        this.part.reset();
        this.file.partsToCreate.add(this.part);
        this.file.partsToUpload.remove(this.part.id);
        this.context.createPartsQueue.add(new CreateParts(this.context, this.file, new Parts().add(this.part)));
    }
    getContent(file, part) {
        return new Promise(async (resolve, reject) => {
            try {
                const originalFile = file.originalFile;
                const originalContent = file.originalContent;
                if (originalContent) {
                    if (typeof originalContent === 'string' || Buffer.isBuffer(originalContent)) {
                        resolve(originalContent);
                    }
                    else {
                        reject(new UnsupportedFileSourceError(`Unsupported inlined file content. Expected 'string' or 'Buffer' as file content but got ${typeof originalContent} instead.`));
                    }
                }
                else if (isNode()) {
                    if (typeof originalFile === 'string') {
                        const content = await this.getContentFromPath(originalFile, part);
                        resolve(content);
                    }
                    else {
                        reject(new UnsupportedFileSourceError(`Unsupported file source. Expected 'string' as file path but got ${typeof originalFile} instead.`));
                    }
                }
                else if (originalFile instanceof File) {
                    const content = await this.getContentFromFile(originalFile, part);
                    resolve(content);
                }
                else {
                    throw new UnsupportedFileSourceError("Unsupported file source.");
                }
            }
            catch (error) {
                reject(error);
            }
        });
    }
    getContentFromFile(originalFile, part) {
        return new Promise((resolve, reject) => {
            try {
                const blob = originalFile.slice(part.startIndex, part.startIndex + part.lengthToRead);
                const reader = new FileReader();
                reader.onerror = (error) => {
                    if (error) {
                        switch (error.name) {
                            case 'NotFoundError':
                                reject(new FileReaderNotFoundError({
                                    message: `The file '${originalFile.name}' could not be found`,
                                    details: {
                                        name: "file",
                                        primary: originalFile.name,
                                    }
                                }));
                                break;
                            case 'SecurityError':
                                reject(new FileReaderSecurityError({
                                    message: `The file '${originalFile.name}' cannot be accessed due to security restrictions`,
                                    details: {
                                        name: "file",
                                        primary: originalFile.name,
                                    }
                                }));
                                break;
                            case 'NotReadableError':
                                reject(new FileReaderNotReadableError({
                                    message: `The file '${originalFile.name}' is not readable or the user has denied permission`,
                                    details: {
                                        name: "file",
                                        primary: originalFile.name,
                                    }
                                }));
                                break;
                            default:
                                reject(new FileReaderUnknownError({
                                    message: `An unknown error occurred while reading the file '${originalFile.name}'`,
                                    details: {
                                        name: "file",
                                        primary: originalFile.name,
                                    }
                                }));
                                break;
                        }
                        ;
                    }
                    else {
                        reject(new FileReaderUnknownError({
                            message: `An unknown error occurred while reading the file '${originalFile.name}'`,
                            details: {
                                name: "file",
                                primary: originalFile.name,
                            }
                        }));
                    }
                    ;
                };
                reader.onabort = () => reject(new FileReaderAbortError({
                    message: `The file reading was aborted for file '${originalFile.name}'`,
                    details: {
                        name: "file",
                        primary: originalFile.name,
                    }
                }));
                reader.onload = (onloadEvent) => {
                    var _a;
                    if ((_a = onloadEvent.target) === null || _a === void 0 ? void 0 : _a.result) {
                        resolve(onloadEvent.target.result);
                    }
                    else {
                        reject(new FileReaderUnknownError({
                            message: `An unknown error occurred while reading the file '${originalFile.name}'`,
                            details: {
                                name: "file",
                                primary: originalFile.name,
                            }
                        }));
                    }
                };
                reader.readAsArrayBuffer(blob);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    getContentFromPath(originalFile, part) {
        return new Promise((resolve, reject) => {
            try {
                const end = part.lengthToRead > 0 ? part.startIndex + part.lengthToRead - 1 : 0;
                const readStream = fs.createReadStream(originalFile, { start: part.startIndex, end });
                let blob = Buffer.from("");
                readStream.on('error', (error) => {
                    if (error.code === 'ENOENT') {
                        reject(new FileSystemNotFoundError({
                            message: `File not found: ${originalFile}`,
                            details: {
                                name: "file",
                                primary: originalFile,
                            }
                        }));
                    }
                    else if (error.code === 'EACCES') {
                        reject(new FileSystemPermissionDeniedError({
                            message: `Permission denied: ${originalFile}`,
                            details: {
                                name: "file",
                                primary: originalFile,
                            }
                        }));
                    }
                    else {
                        reject(new FileSystemUnknownError({
                            message: `An error occurred while reading file: ${originalFile}`,
                            details: {
                                name: "file",
                                primary: originalFile,
                            }
                        }));
                    }
                });
                readStream.on('data', (chunk) => {
                    blob = Buffer.concat([blob, chunk]);
                });
                readStream.on('abort', () => {
                    reject(new FileSystemAbortError({
                        message: `File read operation was aborted: ${originalFile}`,
                        details: {
                            name: "file",
                            primary: originalFile,
                        }
                    }));
                });
                readStream.on('end', () => {
                    resolve(blob);
                });
            }
            catch (error) {
                reject(error);
            }
        });
    }
}
